import api from "../axios";

const getAccountId = () => {
  return sessionStorage.getItem("acc_id");
};

const getLocationId = () => JSON.parse(sessionStorage.getItem("current_loc"))?.id;

const getPatientId = () => sessionStorage.getItem("_pt_id");

export const setPatientDataBounds = async (data, patientId) => {
  const accountId = getAccountId();
  data.patient_id = patientId;
  const response = await api.post(
    `/rpm/${accountId}/patient-thresholds/`,
    data
  );
  return response.data;
};

export const getPatientDataBounds = async (patientId) => {
  const accountId = getAccountId();
  const response = await api.get(
    `/rpm/${accountId}/patient-thresholds/${patientId}/`
  );
  return response.data;
};

export const getPatientStatuses = async () => {
  const accountId = getAccountId();
  const patientId = getPatientId();

  const response = await api.get(`/patients/${accountId}/2/status-patient/`, {
    params: {
      patient: patientId,
    },
  });

  return response.data;
};

export const createPatientStatus = async (data) => {
  const accountId = getAccountId();
  const patientId = getPatientId();
  const payload = {
    patient: patientId,
    status: Number.parseInt(data.status),
    description: data.description,
  };
  const response = await api.post(
    `/patients/${accountId}/2/status-patient/`,
    payload
  );
  return response.data;
};

export const getAllStatusOptions = async () => {
  const accountId = getAccountId();
  const response = await api.get(`/patients/${accountId}/2/status/`);
  return response.data;
};

export const updatePatientStatus = async (statusId, data) => {
  const accountId = getAccountId();
  const patientId = getPatientId();
  data = {
    ...data,
    patient: patientId,
  };
  const response = await api.patch(
    `/patients/${accountId}/2/status-patient/${statusId}/`,
    data
  );
  return response.data;
};

export const deletePatientStatus = async (statusId) => {
  const accountId = getAccountId();

  const response = await api.delete(
    `/patients/${accountId}/2/status-patient/${statusId}/`
  );
  return response.data;
};

// API functions for Notes
export const getPatientNotes = async () => {
  const accountId = getAccountId();
  const locationId = JSON.parse(sessionStorage.getItem("current_loc"))?.id || 554;
  const patientId = getPatientId();
  const response = await api.get(
    `/patients/${accountId}/${locationId}/notes/?patient_id=${patientId}`
  );
  return response.data;
};

export const createPatientNote = async (data, patientId) => {
  const accountId = getAccountId();
  const locationId = JSON.parse(sessionStorage.getItem("current_loc"))?.id || 554;
  const auth_user_id = JSON.parse(localStorage.getItem("user"))?.auth_user_id;

  const payload = {
    patient: patientId,
    note_text: data.note_text,
    note_type: data.note_type,
    location: locationId,
    user_id: auth_user_id
  };

  const response = await api.post(
    `/patients/${accountId}/${locationId}/notes/`,
    payload
  );
  return response.data;
};

export const updatePatientNote = async (noteId, data, patientId) => {
  const accountId = getAccountId();
  const locationId = JSON.parse(sessionStorage.getItem("current_loc"))?.id || 554;

  const payload = {
    patient: patientId,
    note_text: data.note_text,
    location: locationId,
  };

  const response = await api.put(
    `/patients/${accountId}/${locationId}/notes/${noteId}/`,
    payload
  );
  return response.data;
};

export const deletePatientNote = async (noteId) => {
  const accountId = getAccountId();
  const locationId = JSON.parse(sessionStorage.getItem("current_loc"))?.id || 554;

  const response = await api.delete(
    `/patients/${accountId}/${locationId}/notes/${noteId}/`
  );
  return response.data;
};

export const getPatientInfo = async (patientId) => {
  const accountId = getAccountId();
  const response = await api.get(
    `/patients/${accountId}/patients/${patientId}/`
  );
  return response.data;
};

export const updatePatientInfo = async (body, patientId, locationId) => {
  const accountId = getAccountId();
  body.id = patientId;
  const response = await api.patch(
    `/patients/${accountId}/${locationId}/patient/${patientId}/`,
    body
  );
  return response.data;
};

export const createPatientContact = async (data, patientId, locationId) => {
  const accountId = getAccountId();
  data.patient = patientId;
  const response = await api.post(
    `/patients/${accountId}/${locationId}/contact-numbers/`,
    data
  );
  return response.data;
};

export const getPatientContacts = async (patientId, locationId) => {
  const accountId = getAccountId();
  const response = await api.get(
    `/patients/${accountId}/${locationId}/contact-numbers/`,
    {
      params: {
        patient: patientId,
      },
    }
  );
  return response.data;
};

export const deletePatientContact = async (
  contactId,
  patientId,
  locationId
) => {
  const accountId = getAccountId();
  const response = await api.delete(
    `/patients/${accountId}/${locationId}/contact-numbers/${contactId}/`
  );
  return response.data;
};

export const updatePatientContact = async (data, locationId, contactId) => {
  const accountId = getAccountId();
  const response = await api.patch(
    `/patients/${accountId}/${locationId}/contact-numbers/${contactId}/`,
    data
  );
  return response.data;
};

export async function deactivatePatient({ patientId, body }) {
  const accountId = getAccountId();
  const locationId = getLocationId();

  const response = await api.patch(
    `/patients/${accountId}/${locationId}/patient/${patientId}/`,
    body
  );
  return response.data;
}

export async function getPatientSummary() {
  const accountId = getAccountId();
  const locationId = getLocationId();

  const response = await api.get(
    `/patients/${accountId}/${locationId}/patient-summary/`
  );
  return response.data;
}
export const movePatients = async ({ patient_ids = [], to_location_id, current_location_id, reason = "" }) => {
  if (!Array.isArray(patient_ids) || patient_ids.length === 0) {
    throw new Error("No patient ids provided");
  }
  if (!to_location_id) {
    throw new Error("No target location provided");
  }

  const accountId = getAccountId();
  
  const payload = {
    target_location_id: String(to_location_id),
    current_location_id: current_location_id ? String(current_location_id) : undefined,
    reason: reason || "Moved via UI",
    patient_ids: patient_ids,
  };

  const response = await api.post(`/patients/${accountId}/transfer-patients/`, payload);
  
  return response.data;
};